import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useEffect, useState } from 'react'
import { loadEntityLocations } from '../api'

type Status = 'pending' | 'success' | 'fail'

export function useLoadEntityLocationsOnMount(
  entityId: number,
  entityType: ENTITY_TYPES,
  shouldRun: boolean = true,
) {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<Status>(
    shouldRun ? 'pending' : 'success',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          loadEntityLocations({ entityId, entityType }),
        )
        if (mounted) {
          if (loadEntityLocations.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      }
    }
    if (shouldRun) execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityId, entityType, shouldRun])

  return status
}
